





































































import { Component, Vue } from 'vue-property-decorator';
import { PaywallFeature } from 'frontend/types/premium';
import { getFeatureList } from 'frontend/views/premium/features';

@Component({})
export default class PaywallFeaturesList extends Vue {
  private get features(): PaywallFeature[] {
    return getFeatureList();
  }
}
